import { desktopBlur, type FlowThemeCardMotion } from '../../cardMotion';

/** The card dims out like a window switching off, and the next one glows up. */
export const cityCardMotion = (isMobile: boolean): FlowThemeCardMotion => ({
  variants: {
    enter: () => ({ opacity: 0, scale: 1.04, filter: desktopBlur(isMobile, 6) }),
    center: { opacity: 1, scale: 1, filter: isMobile ? undefined : 'blur(0px)' },
    exit: () => ({ opacity: 0, scale: 0.96, filter: desktopBlur(isMobile, 4) }),
  },
  transition: { duration: 0.7, ease: [0.33, 1, 0.68, 1] },
});
